import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    workUnitChannel = new Subject();
    employeeStatusChannel = new Subject();
    echelonChannel = new Subject();
    exportExcelChannel = new Subject();

    indexChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
        this.employeeStatusChannel.next({status: apiResponse.INITIAL})
        this.exportExcelChannel.next({status: apiResponse.INITIAL})
        this.workUnitChannel.next({status: apiResponse.INITIAL})
        this.echelonChannel.next({status: apiResponse.INITIAL})
    }

    fetchExportExcel = async (query) => {
        try {
            this.exportExcelChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExportExcel(query).then((result) => {
                this.exportExcelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportExcelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchWorkUnit = async (query) => {
        try {
            this.workUnitChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchWorkUnit(query).then((result) => {
                this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchEmployeeStatus = async (query) => {
        try {
            this.employeeStatusChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployeeStatus(query).then((result) => {
                this.employeeStatusChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeStatusChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'channel unsubscribed')   
        }
    }

    fetchEchelon = async (query) => {
        try {
            this.echelonChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEchelon(query).then((result) => {
                this.echelonChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.echelonChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('rxjs', 'channel unsubscribed') }
    }
}

export default IndexBloc